module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_32.4deb5479.mp3";